module.exports = __webpack_public_path__ + "img/unionDel.53396f35.svg";